import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const imgUploadApiSlice = createApi({
  reducerPath: "imgApi",
  baseQuery: fetchBaseQuery({ baseUrl: "https://api.imgbb.com/1" }),
  endpoints: (builder) => ({
    uploadImg: builder.mutation({
      query: (data) => ({
        url: "/upload",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useUploadImgMutation } = imgUploadApiSlice;
